import { Pointers } from "@opendaw/studio-enums";
import { Notifier, Terminator } from "@opendaw/lib-std";
import { IndexedBoxAdapterCollection } from "../IndexedBoxAdapterCollection";
import { ClipAdapters } from "./ClipBoxAdapter";
export class TrackClips {
    #trackBoxAdapter;
    #terminator;
    #changeNotifier;
    #collection;
    constructor(adapter, boxAdapters) {
        this.#trackBoxAdapter = adapter;
        this.#terminator = new Terminator();
        this.#changeNotifier = this.#terminator.own(new Notifier());
        this.#collection = this.#terminator.own(IndexedBoxAdapterCollection.create(adapter.box.clips, box => ClipAdapters.for(boxAdapters, box), Pointers.ClipCollection));
        this.#collection.subscribe({
            onAdd: () => this.dispatchChange(),
            onRemove: () => this.dispatchChange(),
            onReorder: () => this.dispatchChange()
        });
    }
    get trackBoxAdapter() { return this.#trackBoxAdapter; }
    get collection() { return this.#collection; }
    dispatchChange() { this.#changeNotifier.notify(); }
    subscribeChanges(observer) { return this.#changeNotifier.subscribe(observer); }
    terminate() { this.#terminator.terminate(); }
}
